<template>
  <img :src="imageSrc + '?$staticlink$'" style="max-width: 100%" />
</template>

<script setup>
import { fieldFactory } from '@/helper/popFieldFactory';
const props = defineProps({
    popStoreId:String
})

const imageSrc = fieldFactory('imageSrc', props.popStoreId)
</script>

<style>

</style>